/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { SvgHandler } from '../../../svg-handler/svg-handler';
import success from '../../../../../assets/icons/success.svg';
import { getTextContrast, getSubscriptionRedirect, getPath } from '../../../../utils';
import { QUILL_EMPTY_STRING } from '../../../../constants';
import './success.m.css';
import { useSelector } from 'react-redux';

export const SubscriptionSuccess = props => {
  const sketchesHost = get(props, ['config', 'sketches-host'], '');
  const pbConfig = get(props, ['config', 'pagebuilder-config'], {});
  const { primaryColor = '#4860BC', darkPrimaryColor = '#4860BC' } = get(pbConfig, ['general'], {});
  const enableDarkMode = useSelector(state => get(state, ['header', 'isDarkModeEnabled'], false));
  const thankYouPageSettings = get(pbConfig, ['subscription', 'pageSetting'], {});

  const {
    continueReading,
    goToHome,
    goToProfile,
    buttonColor = primaryColor,
    darkButtonColor = darkPrimaryColor
  } = thankYouPageSettings;

  const { thankYouPageTitle, thankYouPageDescription } = getTitleAndDescription(thankYouPageSettings);

  const buttonBgColor = enableDarkMode ? darkButtonColor : buttonColor;
  const textColor = getTextContrast(buttonBgColor) === 'dark' ? '#000' : '#fff';
  const whiteListedUrlParams = get(pbConfig, ['general', 'others', 'whiteListedUrlParams'], []);
  return (
    <div styleName='wrapper'>
      <SvgHandler xlinkHref={success} width='24' height='24' viewBox='0 0 24 24' clazzName={''} />
      <div styleName='title' dangerouslySetInnerHTML={{ __html: thankYouPageTitle }} />
      <div styleName='content' dangerouslySetInnerHTML={{ __html: thankYouPageDescription }} />
      <div styleName='button-wrapper'>
        <div>
          <ContinueReadingButton continueReading={continueReading} textColor={textColor} />
          <GoToProfileButton
            goToProfile={goToProfile}
            sketchesHost={sketchesHost}
            whiteListedUrlParams={whiteListedUrlParams}
          />
        </div>
      </div>
      <GoToHomeLink sketchesHost={sketchesHost} goToHome={goToHome} />
    </div>
  );
};

function getTitleAndDescription (thankYouPageSettings) {
  let { thankYouPageTitle, thankYouPageDescription } = thankYouPageSettings;

  if (!thankYouPageTitle || thankYouPageTitle === QUILL_EMPTY_STRING) {
    thankYouPageTitle = 'Thank you for placing your order!';
  }

  if (!thankYouPageDescription || thankYouPageDescription === QUILL_EMPTY_STRING) {
    thankYouPageDescription =
      'We kindly ask for your patience as we process it (approx. 15min). Please check your email for further details and updates';
  }

  return { thankYouPageTitle, thankYouPageDescription };
}

function GoToHomeLink ({ goToHome, sketchesHost }) {
  const href = getPath({ sketchesHost, relativePath: `/` });
  return (
    <a href={href} styleName='goto-home-link '>
      {goToHome || 'Go to Home'}
    </a>
  );
}

function GoToProfileButton ({ goToProfile, sketchesHost, whiteListedUrlParams = [] }) {
  const fallbackText = 'Manage Subscriptions';
  const href = getPath({
    sketchesHost,
    relativePath: '/manage-subscriptions',
    injectCustomParams: true,
    whiteListedUrlParams,
  });
  return (
    <a href={href} styleName='button goto-profile-button'>
      {goToProfile || fallbackText}
    </a>
  );
}

function ContinueReadingButton ({ continueReading, textColor }) {
  const [buttonClicked, setButtonClicked] = useState(false);

  useEffect(() => {
    if (!buttonClicked) return;
    const redirectUrl = getSubscriptionRedirect() || window?.qtMountAt || '/';
    window.location.href = redirectUrl;
  }, [buttonClicked]);

  return (
    <div onClick={() => setButtonClicked(true)} styleName='button continue-reading-button' style={{ color: textColor }}>
      {continueReading || 'Continue Reading'}
    </div>
  );
}
